import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, BLUE_500, getTestId, InfoIcon, InfoTag, tokens, Tooltip, useBreakpoint } from '@airtel/air-design-system';
import { useState } from 'react';
import { Pressable } from 'react-native';
import { View } from 'react-native';
import { InfoListConstants } from '../../InfoListWidgetsConstants';
import ClickableTypography from '../clickable-typohraphy/ClickableTypography';
import { getAccordianChildStyle } from './AccordianChildStyles';
function AccordianChildComponent(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18;
  var _props$item = props.item,
    item = _props$item === void 0 ? {} : _props$item,
    index = props.index,
    list = props.list,
    onUserAction = props.onUserAction,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'InfoListAccordianChild' : _props$testID;
  var _useState = useState(false),
    leftToolTip = _useState[0],
    setLeftToolTipState = _useState[1];
  var _useState2 = useState(false),
    rightToolTip = _useState2[0],
    setRightToolTipState = _useState2[1];
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var accordianChildStyle = getAccordianChildStyle((_b = (_a = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _a === void 0 ? void 0 : _a.showToolTip) !== null && _b !== void 0 ? _b : false, (_d = (_c = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _c === void 0 ? void 0 : _c.showToolTip) !== null && _d !== void 0 ? _d : false, isLargeScreen, index, list);
  var onInfoIconPress = (iconPressMetaData, stateSetterFunction, id, item) => {
    stateSetterFunction(prev => !prev);
    iconPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, iconPressMetaData), item));
  };
  return _jsxs(View, Object.assign({
    testID: testID,
    style: accordianChildStyle.singleContainerWrapper
  }, {
    children: [_jsxs(View, Object.assign({
      style: accordianChildStyle.singleElementWrapper
    }, {
      children: [_jsxs(View, Object.assign({
        style: accordianChildStyle.singleItemComponent
      }, {
        children: [!!((_e = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _e === void 0 ? void 0 : _e.text) && _jsx(View, Object.assign({
          style: accordianChildStyle.singleItemLeftText
        }, {
          children: _jsx(ClickableTypography, Object.assign({
            text: (_g = (_f = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _f === void 0 ? void 0 : _f.text) !== null && _g !== void 0 ? _g : '',
            color: (_j = (_h = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _h === void 0 ? void 0 : _h.color) !== null && _j !== void 0 ? _j : BLACK_900
          }, item === null || item === void 0 ? void 0 : item.leftDetails, {
            type: isLargeScreen ? InfoListConstants.BODY_PARA_MD : InfoListConstants.BODY_PARA_SM,
            onUserAction: onUserAction
          }))
        })), !!((_k = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _k === void 0 ? void 0 : _k.showToolTip) && _jsx(Tooltip, Object.assign({
          text: (_o = (_m = (_l = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _l === void 0 ? void 0 : _l.toolTipProps) === null || _m === void 0 ? void 0 : _m.text) !== null && _o !== void 0 ? _o : '',
          position: "top-start",
          offset: {
            x: -10,
            y: -6
          },
          isVisible: leftToolTip,
          onClose: () => {
            var _a, _b;
            if ((_b = (_a = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _a === void 0 ? void 0 : _a.toolTipProps) === null || _b === void 0 ? void 0 : _b.autoHide) {
              setLeftToolTipState(false);
            }
          },
          testID: (_r = (_q = (_p = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _p === void 0 ? void 0 : _p.toolTipProps) === null || _q === void 0 ? void 0 : _q.id) !== null && _r !== void 0 ? _r : 'InfoList-Child-RightToolTip',
          autoHide: true,
          autoHideTimeout: 5000
        }, (_s = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _s === void 0 ? void 0 : _s.toolTipProps, getTestId(item === null || item === void 0 ? void 0 : item.testID, 'showInfoIcon'), {
          children: _jsx(Pressable, Object.assign({
            onPress: () => {
              var _a, _b, _c;
              return onInfoIconPress((_b = (_a = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _a === void 0 ? void 0 : _a.toolTipProps) === null || _b === void 0 ? void 0 : _b.onInfoIconPressMetaData, setLeftToolTipState, (_c = item === null || item === void 0 ? void 0 : item.id) !== null && _c !== void 0 ? _c : 'infoIconPress', item);
            }
          }, {
            children: _jsx(InfoIcon, Object.assign({
              color: BLUE_500,
              fontSize: tokens.spacing.SPACING_16
            }, getTestId((_t = item === null || item === void 0 ? void 0 : item.testID) !== null && _t !== void 0 ? _t : '', 'infoIcon')))
          }))
        }))]
      })), !!((_u = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _u === void 0 ? void 0 : _u.showInfoTag) && _jsx(View, Object.assign({
        style: accordianChildStyle.infoTagContainer
      }, {
        children: _jsx(InfoTag, Object.assign({}, (_v = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _v === void 0 ? void 0 : _v.infoTagProps, {
          size: isLargeScreen ? InfoListConstants.MD : InfoListConstants.SM
        }))
      })), !!((_w = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _w === void 0 ? void 0 : _w.subText) && ((_y = (_x = item === null || item === void 0 ? void 0 : item.leftDetails) === null || _x === void 0 ? void 0 : _x.subText) === null || _y === void 0 ? void 0 : _y.map((subTextItem, index) => {
        return _jsx(ClickableTypography, Object.assign({
          onUserAction: onUserAction,
          color: BLACK_700
        }, subTextItem, {
          type: isLargeScreen ? InfoListConstants.BODY_PARA_SM : InfoListConstants.BODY_PARA_XS
        }), "#" + index);
      }))]
    })), _jsxs(View, Object.assign({
      style: accordianChildStyle.singleElementWrapperRight
    }, {
      children: [_jsxs(View, Object.assign({
        style: accordianChildStyle.singleItemRightComponent
      }, {
        children: [_jsxs(View, Object.assign({
          style: accordianChildStyle.singleItemComponent
        }, {
          children: [!!((_z = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _z === void 0 ? void 0 : _z.text) && _jsx(View, Object.assign({
            style: accordianChildStyle.singleItemRightText
          }, {
            children: _jsx(ClickableTypography, Object.assign({
              onPress: (_1 = (_0 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _0 === void 0 ? void 0 : _0.onPress) !== null && _1 !== void 0 ? _1 : null,
              onUserAction: onUserAction,
              text: (_2 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _2 === void 0 ? void 0 : _2.text,
              color: (_4 = (_3 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _3 === void 0 ? void 0 : _3.color) !== null && _4 !== void 0 ? _4 : BLACK_900
            }, item === null || item === void 0 ? void 0 : item.rightDetails, {
              type: isLargeScreen ? InfoListConstants.BODY_PARA_MD : InfoListConstants.BODY_PARA_SM
            }))
          })), ((_6 = !!((_5 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _5 === void 0 ? void 0 : _5.showToolTip)) !== null && _6 !== void 0 ? _6 : false) && _jsx(Tooltip, Object.assign({
            text: (_9 = (_8 = (_7 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _7 === void 0 ? void 0 : _7.toolTipProps) === null || _8 === void 0 ? void 0 : _8.text) !== null && _9 !== void 0 ? _9 : '',
            position: "top-end",
            style: accordianChildStyle.toolTipStyle,
            offset: {
              x: -10,
              y: -6
            },
            isVisible: rightToolTip,
            onClose: () => {
              var _a, _b;
              if ((_b = (_a = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _a === void 0 ? void 0 : _a.toolTipProps) === null || _b === void 0 ? void 0 : _b.autoHide) {
                setRightToolTipState(false);
              }
            },
            testID: (_11 = (_10 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _10 === void 0 ? void 0 : _10.toolTipProps.id) !== null && _11 !== void 0 ? _11 : 'InfoList-Child-RightToolTip',
            autoHide: true,
            autoHideTimeout: 5000
          }, (_12 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _12 === void 0 ? void 0 : _12.toolTipProps, getTestId((_13 = item === null || item === void 0 ? void 0 : item.testID) !== null && _13 !== void 0 ? _13 : '', 'showInfoIcon'), {
            children: _jsx(Pressable, Object.assign({
              onPress: () => {
                var _a, _b, _c;
                return onInfoIconPress((_b = (_a = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _a === void 0 ? void 0 : _a.toolTipProps) === null || _b === void 0 ? void 0 : _b.onInfoIconPressMetaData, setRightToolTipState, (_c = item === null || item === void 0 ? void 0 : item.id) !== null && _c !== void 0 ? _c : 'infoIconPress', item);
              }
            }, {
              children: _jsx(InfoIcon, Object.assign({
                color: BLUE_500,
                fontSize: tokens.spacing.SPACING_16
              }, getTestId((_14 = item === null || item === void 0 ? void 0 : item.testID) !== null && _14 !== void 0 ? _14 : '', 'infoIcon')))
            }))
          }))]
        })), !!((_15 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _15 === void 0 ? void 0 : _15.showInfoTag) && _jsx(View, Object.assign({
          style: accordianChildStyle.infoTagWrapperStyles
        }, {
          children: _jsx(InfoTag, Object.assign({}, (_16 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _16 === void 0 ? void 0 : _16.infoTagProps, {
            size: isLargeScreen ? InfoListConstants.MD : InfoListConstants.SM
          }))
        }))]
      })), ((_17 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _17 === void 0 ? void 0 : _17.subText) && ((_18 = item === null || item === void 0 ? void 0 : item.rightDetails) === null || _18 === void 0 ? void 0 : _18.subText.map((subTextItem, index) => {
        return _jsx(View, Object.assign({
          style: accordianChildStyle.subTextWrapper
        }, {
          children: _jsx(ClickableTypography, Object.assign({
            onUserAction: onUserAction,
            color: BLACK_700
          }, subTextItem, {
            type: isLargeScreen ? InfoListConstants.BODY_PARA_SM : InfoListConstants.BODY_PARA_XS
          }))
        }), "#" + index);
      }))]
    }))]
  }));
}
export default AccordianChildComponent;